import request from '@/api-v2/request';
import type { IUserInfoResponse } from './types/IUserInfoResponse';
import type { IUserProviderResponse } from './types/IUserProviderResponse';
import type { IUpdateUser } from './types/IUpdateUser';
import type { ITeamResponse } from './types/ITeamResponse';
import type { IUpdateTeamParameter } from './types/IUpdateTeamParameter';
import type { ITeamParameter } from './types/ITeamParameter';
import type { UserSubTeamResponseDTO } from './types/UserSubTeamResponseDTO';

export const getUserInfo = (signal: AbortSignal): Promise<IUserInfoResponse> =>
  request({
    url: `/user`,
    method: 'get',
    signal,
  }).then((o) => o.data);

export const getUserProvider = (signal: AbortSignal): Promise<IUserProviderResponse> =>
  request({
    url: `/user/provider`,
    method: 'get',
    signal,
  }).then((o) => o.data);

export const updateUserInfo = (user: IUpdateUser): Promise<IUserInfoResponse> =>
  request({
    url: `/user`,
    method: 'put',
    data: user,
  }).then((o) => o.data);

export const getTeamInfo = (signal: AbortSignal): Promise<ITeamResponse> =>
  request({
    url: `/user/team`,
    method: 'get',
    signal,
  }).then((o) => o.data);

export const getTeamParameters = (signal: AbortSignal): Promise<ITeamParameter> =>
  request({
    url: `/user/team/parameters`,
    method: 'get',
    signal,
  }).then((o) => o.data);

export const updateTeamParameters = (body: IUpdateTeamParameter, signal?: AbortSignal): Promise<ITeamParameter> =>
  request({
    url: `/user/team/parameters`,
    method: 'post',
    data: body,
    signal,
  }).then((o) => o.data);

export const getSubTeams = (signal: AbortSignal): Promise<UserSubTeamResponseDTO> =>
  request({
    url: `/user/sub-team`,
    method: 'get',
    signal,
  }).then((o) => o.data);
